import Icon from '../components/Icon.vue'

Icon.register({"crop":{"width":1664,"height":1792,"paths":[{"d":"M557 1280h595v-595zM512 1235l595-595h-595v595zM1664 1312v192q0 14-9 23t-23 9h-224v224q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-224h-864q-14 0-23-9t-9-23v-864h-224q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h224v-224q0-14 9-23t23-9h192q14 0 23 9t9 23v224h851l246-247q10-9 23-9t23 9q9 10 9 23t-9 23l-247 246v851h224q14 0 23 9t9 23z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/crop.js
// module id = 1309
// module chunks = 0